<template>
  <v-card tile v-if="employee !== null">
    <v-card-title>
      <v-row>
        <v-col cols="12" xl="8">
          <span
            >Aktivnost zaposlenega {{ employee.first_name }}
            {{ employee.last_name }}</span
          >
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="employeeActivity.data"
        :page.sync="employeeActivity.current_page"
        :items-per-page="employeeActivity.per_page"
        :server-items-length="employeeActivity.total"
        :options.sync="tableOptions"
        @update:options="loadEmployeeActivity"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
        sort-by="id"
        class="elevation-1"
        @click:row="showPayload"
      >
        <template v-slot:[`item.activity`]="{ item }">
          {{ getActivityText(item.activity) }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ $moment(item.created_at).format("DD.MM.YYYY HH:mm") }}
        </template>
        <template v-slot:[`item.user_id`]="{ item }">
          {{ item.user ? item.user.name : "" }}
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadEmployeeActivity">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      employee: null,
      employeeActivity: {
        data: [],
      },
      headers: [
        { text: "Ime", value: "activity" },
        { text: "Datum", value: "created_at" },
        { text: "Administrator", value: "user_id" },
      ],

      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["created_at"],
        sortDesc: [true],
      },
    }),
    mounted() {
      this.loadEmployee();
      this.loadEmployeeActivity();
    },
    methods: {
      loadEmployee() {
        this.$http
          .get("api/v1/employees/" + this.$route.params.employeeId)
          .then((response) => {
            this.employee = response.data;
          })
          .catch(() => {
            this.$router.push({ name: "Employees" });
          });
      },
      loadEmployeeActivity() {
        let orderBy = {};
        if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
        ) {
          orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
        }
        let params = {
          page: this.tableOptions.page,
          perPage: this.tableOptions.itemsPerPage,
          orderBy,
          filters: { employee_id: this.$route.params.employeeId },
        };
        this.$http
          .get("api/v1/employee-activity", { params })
          .then((response) => {
            this.employeeActivity = response.data;
          });
      },
      getActivityText(activity) {
        let activities = {
          "employee-created": "Zaposleni ustvarjen",
          "employee-updated": "Zaposleni urejan",
          "employee-deleted": "Zaposleni izbrisan",
          "vehicle-assigned": "Vozilo dodeljeno",
          "vehicle-unassigned": "Vozilo odvzeto",
        };

        return activities[activity] ?? activity;
      },
      showPayload(activity) {
        // This is some very ugly code that will probably be rewritten.
        // Basicaly, if activity type is employee-updated, we create html table with all changes.
        // Also, big xss risk :)

        let payload = JSON.parse(activity.payload);

        if (
          activity.activity === "vehicle-assigned" ||
          activity.activity === "vehicle-unassigned"
        ) {
          this.$router.push({
            name: "Vehicle",
            params: { id: payload.vehicle_id },
          });
          return;
        }

        if (activity.activity === "employee-updated") {
          let table =
            '<table border="1"><tr><th>Parameter</th> <th>Stara vrednost</th><th>Nova vrednost</th><tr>';
          for (let index = 0; index < payload.length; index++) {
            const element = payload[index];
            table +=
              "<tr><td>" +
              element.column +
              "</td><td>" +
              element.old_value +
              "</td><td>" +
              element.new_value +
              "</td><tr>";
          }
          table += "</table>";
          this.$swal({
            title: "Dodatne informacije",
            html: table,
          });
        }
      },
    },
  };
</script>
<style></style>
